import { useEffect, useState } from "react"
import { Toaster as Sonner, toast } from "sonner"

// The app controls light/dark via the `dark` class on <html> (see ThemeToggle),
// not next-themes. Read that directly so toasts always match the site palette
// and never render OS-dark text on a light card (or vice-versa).
const useAppTheme = () => {
  const read = () =>
    typeof document !== "undefined" && document.documentElement.classList.contains("dark") ? "dark" : "light"
  const [theme, setTheme] = useState(read)
  useEffect(() => {
    const obs = new MutationObserver(() => setTheme(read()))
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] })
    return () => obs.disconnect()
  }, [])
  return theme
}

const Toaster = ({ ...props }) => {
  const theme = useAppTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      style={{
        "--normal-bg": "var(--surface)",
        "--normal-text": "var(--ink)",
        "--normal-border": "var(--line)",
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-[var(--surface)] !text-[var(--ink)] !border !border-[var(--line)] shadow-lg",
          title: "!text-[var(--ink)] font-medium",
          description: "!text-[var(--ink-2)]",
          actionButton: "!bg-[var(--saffron)] !text-white",
          cancelButton: "!bg-[var(--surface-alt)] !text-[var(--ink-2)]",
          closeButton: "!bg-[var(--surface-alt)] !text-[var(--ink-2)] !border-[var(--line)]",
          icon: "!text-[var(--saffron)]",
          error: "!text-[var(--ink)]",
          success: "!text-[var(--ink)]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
